import fabric from './useFabricObject';
const f = fabric.Image.filters;
export var FilterNames;
(function (FilterNames) {
    FilterNames["GRAYSCALE"] = "grayscale";
    FilterNames["INVERT"] = "invert";
    FilterNames["REMOVE_COLOR"] = "remove-color";
    FilterNames["SEPIA"] = "sepia";
    FilterNames["BROWNIE"] = "brownie";
    FilterNames["BRIGHTNESS"] = "brightness";
    FilterNames["CONTRAST"] = "contrast";
    FilterNames["SATURATION"] = "saturation";
    FilterNames["VIBRANCE"] = "vibrance";
    FilterNames["NOISE"] = "noise";
    FilterNames["VINTAGE"] = "vintage";
    FilterNames["PIXELATE"] = "pixelate";
    FilterNames["BLUR"] = "blur";
    FilterNames["SHARPEN"] = "sharpen";
    FilterNames["EMBOSS"] = "emboss";
    FilterNames["TECHNICOLOR"] = "technicolor";
    FilterNames["POLAROID"] = "polaroid";
    FilterNames["BLEND_COLOR"] = "blend-color";
    FilterNames["GAMMA"] = "gamma";
    FilterNames["KODACHROME"] = "kodachrome";
    FilterNames["BLACK_WHITE"] = "blackwhite";
    FilterNames["BLEND_IMAGE"] = "blend-image";
    FilterNames["HUE"] = "hue";
    FilterNames["RESIZE"] = "resize";
})(FilterNames || (FilterNames = {}));
export function getFilter(filterName, value) {
    let imageFilter;
    let index = 100;
    try {
        switch (filterName) {
            case FilterNames.GRAYSCALE:
                index = 0;
                imageFilter = new f.Grayscale();
                break;
            case FilterNames.INVERT:
                index = 1;
                imageFilter = new f.Invert();
                break;
            case FilterNames.REMOVE_COLOR:
                index = 2;
                imageFilter = new f.RemoveColor({
                    distance: value.distance,
                    color: value.color,
                });
                break;
            case FilterNames.SEPIA:
                index = 3;
                imageFilter = new f.Sepia();
                break;
            case FilterNames.BROWNIE:
                index = 4;
                imageFilter = new f.Brownie();
                break;
            case FilterNames.BRIGHTNESS:
                index = 5;
                imageFilter = new f.Brightness({ brightness: value });
                break;
            case FilterNames.CONTRAST:
                index = 6;
                imageFilter = new f.Contrast({ contrast: value });
                break;
            case FilterNames.SATURATION:
                index = 7;
                imageFilter = new f.Saturation({ saturation: value });
                break;
            case FilterNames.VIBRANCE:
                index = 8;
                imageFilter = new f.Vibrance({ vibrance: value });
                break;
            case FilterNames.NOISE:
                index = 9;
                imageFilter = new f.Noise({ noise: value });
                break;
            case FilterNames.VINTAGE:
                index = 10;
                imageFilter = new f.Vintage();
                break;
            case FilterNames.PIXELATE:
                index = 11;
                imageFilter = new new f.Pixelate({ blocksize: value })();
                break;
            case FilterNames.BLUR:
                index = 12;
                imageFilter = new new f.Blur({ blur: value })();
                break;
            case FilterNames.SHARPEN:
                index = 13;
                imageFilter = new f.Convolute({
                    matrix: [0, -1, 0, -1, 5, -1, 0, -1, 0],
                });
                break;
            case FilterNames.EMBOSS:
                index = 14;
                imageFilter = new f.Convolute({
                    matrix: [1, 1, 1, 1, 0.7, -1, -1, -1, -1],
                });
                break;
            case FilterNames.TECHNICOLOR:
                index = 15;
                imageFilter = new f.Technicolor();
                break;
            case FilterNames.POLAROID:
                index = 16;
                imageFilter = new f.Polaroid();
                break;
            case FilterNames.BLEND_COLOR:
                index = 17;
                new f.BlendColor({
                    color: value.blend.color,
                    mode: value.blend.mode,
                    alpha: value.blend.alpha,
                });
                break;
            case FilterNames.GAMMA:
                index = 18;
                imageFilter = new f.Gamma({
                    gamma: [value.red, value.green, value.blue],
                });
                break;
            case FilterNames.KODACHROME:
                index = 19;
                imageFilter = new f.Kodachrome();
                break;
            case FilterNames.BLACK_WHITE:
                index = 20;
                imageFilter = new f.BlackWhite();
                break;
            case FilterNames.BLEND_IMAGE:
                index = 21;
                imageFilter = new f.BlendImage({
                    image: value,
                    mode: 'multiply',
                });
                break;
            case FilterNames.HUE:
                index = 22;
                imageFilter = new f.HueRotation({
                    rotation: value,
                });
                break;
            case FilterNames.RESIZE:
                index = 23;
                break;
        }
        return Promise.resolve({ filter: imageFilter, index });
    }
    catch (error) {
        return Promise.resolve({ filter: imageFilter, index });
    }
}
